'use strict';

import {downloadResource} from "../jquery-functions-library";
import {element_exists} from "../functions";

export var fnDownloadSalaryInFormat = function () {

    var element = '#btn-download-payroll';

    if (!element_exists(element)) return false;

    var btnDownload = $(element);

    $.ajaxSetup({headers: {'X-CSRF-TOKEN': $('[name="_token"]').val()}});

    btnDownload.on('click', function (e) {

        e.preventDefault();

        var payrollId = $('#selected_payroll').attr('value');

        var url = '/salary/payrolls/download/' + payrollId + '/csv';

        downloadResource(url);
    });
};